module.exports = __webpack_public_path__ + "static/media/android.3829be70.png";